export const sexList = [
    {
        description: 'sexList.male',
        label: 'sexList.male',
        type: 'sexList',
        value: '1'
    },
    {
        description: 'sexList.female',
        label: 'sexList.female',
        type: 'sexList',
        value: '2'
    }
];

export default sexList;